/**
 * External Imports
 */
import { FC, useMemo } from 'react';
import { sub } from 'date-fns';

/**
 * Nexus Imports
 */
import { NeuInput } from '@neutron/react';

/**
 * Internal Imports
 */
import { date as dt } from '../../../../utils/helpers';

/**
 * Style Imports
 */
import { DateContainer, SelectContainer } from './DateSelectsSection.styles';

const DateSelectsSection: FC<{
  filterType?: string;
  startDate?: string;
  endDate?: string;
  style?: {};
  handleSelects: (e: CustomEvent<any>) => void;
}> = ({ filterType, startDate, endDate, style, handleSelects }) => {
  const minStartDate = useMemo(
    () => dt.convertToDayOfYear(sub(new Date(), { years: 2 })),
    []
  );
  const maxStartDate = useMemo(
    () =>
      endDate
        ? dt.convertToDayOfYear(dt.localDayOfYearDate(endDate))
        : dt.convertToDayOfYear(new Date()),
    [endDate]
  );
  const minEndDate = useMemo(
    () =>
      startDate
        ? dt.convertToDayOfYear(dt.localDayOfYearDate(startDate))
        : dt.convertToDayOfYear(new Date()),
    [startDate]
  );
  const maxEndDate = useMemo(
    () =>
      filterType === 'complianceReport'
        ? dt.convertToDayOfYear(sub(new Date(), { days: 1 }))
        : dt.convertToDayOfYear(new Date()),
    []
  );

  return (
    <DateContainer id="Modal-Date-Selection" style={style}>
      <SelectContainer>
        {/* TODO: This needs to be a datepicker */}
        <NeuInput
          id="Modal-Date-Selection-Start-Day"
          label="Start Date"
          name="startDate"
          type="date"
          autocomplete="off"
          inputMode="search"
          autoCorrect="off"
          min={minStartDate}
          max={maxStartDate}
          required
          value={startDate}
          onNeuChange={handleSelects}
        />
      </SelectContainer>
      <SelectContainer>
        <NeuInput
          id="Modal-Date-Selection-End-Day"
          label="End Date"
          name="endDate"
          type="date"
          autocomplete="off"
          inputMode="search"
          autoCorrect="off"
          min={minEndDate}
          max={maxEndDate}
          required
          value={endDate}
          onNeuChange={handleSelects}
        />
      </SelectContainer>
    </DateContainer>
  );
};

export default DateSelectsSection;
